import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    creationSuccessMessage: 'Your virtual card has been created',
    deactivation: 'Deactivation date',
    description: 'Verify the information of your order before validating it:',
    errorBoxNotEnoughFunds:
      'There are insufficient funds to cover this order, please make sure your balance is sufficient to order your card.',
    freeOrderCta: 'Create my card',
    orderErrorMessage:
      'An error occurred while ordering your card. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    paidOrderCta: 'Create my card',
    permanent: 'Permanent',
    price: 'Price',
    priceFree: '**Free**',
    pricePerMonth: '**€{0}**/month',
    quotaWarning: {
      multipleLeft:
        'You still have {cardsLeft} virtual cards included in your {plan} plan.',
      noneInQuota:
        'Your card is charged €{price} on the day it is created and then €{price} every month, on the date of renewal of your subscription, until the card is permanently deactivated.',
      oneLeft: 'You still have 1 virtual card included in your {plan} plan.',
      zeroLeft:
        'You have used all the virtual cards included in your {plan} plan. Each new card will be charged €{price} on the day it is created and then €{price} every month, on the date of renewal of your subscription, until the card is permanently deactivated.',
    },
    temporary: 'Temporary',
    title: 'Your order summary',
    unspecifiedDeactivationDate: 'Unspecified',
    usage: 'Usage',
    vatMention: 'Prices are displayed without VAT.',
    virtualCardName: `{0} virtual`,
  },
  fr: {
    creationSuccessMessage: 'Votre carte virtuelle a été créée',
    deactivation: 'Date de désactivation',
    description:
      'Vérifiez les informations de votre commande avant de la valider :',
    errorBoxNotEnoughFunds:
      'Les fonds sont insuffisants pour cette commande, veuillez vous assurer que votre solde est suffisant pour commander votre carte.',
    freeOrderCta: 'Créer ma carte',
    orderErrorMessage:
      'Une erreur est survenue lors de la commande de votre carte. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    paidOrderCta: 'Créer ma carte',
    permanent: 'Permanent',
    price: 'Prix',
    priceFree: '**Gratuit**',
    pricePerMonth: '**{0}\xA0€**/mois',
    quotaWarning: {
      multipleLeft:
        'Il vous reste {cardsLeft} cartes virtuelles incluses dans votre plan {plan}.',
      noneInQuota:
        'Votre carte vous est facturée {price}\xA0€ le jour de sa création puis {price}\xA0€ tous les mois, à la date de renouvellement de votre abonnement, jusqu’à désactivation définitive de la carte.',
      oneLeft:
        'Il vous reste 1 carte virtuelle incluse dans votre plan {plan}.',
      zeroLeft:
        'Vous avez utilisé toutes les cartes virtuelles incluses dans votre plan {plan}.\nChaque nouvelle carte vous sera facturée {price}\xA0€ le jour de sa création puis {price}\xA0€ tous les mois, à la date de renouvellement de votre abonnement, jusqu’à désactivation définitive de la carte.',
    },
    temporary: 'Temporaire',
    title: 'Récapitulatif de votre commande',
    unspecifiedDeactivationDate: 'Non définie',
    usage: 'Usage',
    vatMention: 'Les prix sont affichés hors taxes.',
    virtualCardName: `{0} virtuelle`,
  },
});

export default locales;
